import React from 'react';
import { IconProps } from '../../../../../types/components';

export default function AngleDown({ iconClass, width, height }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
      role="img"
      viewBox="0 0 448 512"
      className={iconClass}
      width={width}
      height={height}
    >
      <path fill="currentColor" d="M224 385.9l17-17L401 209l17-17L384 158.1l-17 17-143 143L81 175l-17-17L30.1 192l17 17L207 369l17 17z" />
    </svg>
  );
}
